import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const OverviewSection = lazy(() => import("./OverviewSection"));
const DynamicLearningSection = lazy(() => import("./DynamicLearningSection"));
const BenefitSection = lazy(() => import("./BenefitSection"));
const SupportSection = lazy(() => import("./SupportSection"));
const FeaturesSection = lazy(() => import("./FeaturesSection"));

const Education = () => {
  return (
    <main className="bg-white">
      <Helmet>
        <title>
          Education Programs | Hands-on Training & Skill Development | Lentera
        </title>

        <meta
          name="description"
          content="Empower students with LENTERA’s dynamic education programs. Gain industry-relevant skills, hands-on training, personalized dashboards and seamless access to resources for academic success and career readiness."
        />

        <meta
          name="keywords"
          content="LENTERA education programs, hands-on training, skill development, learning platforms"
        />
      </Helmet>

      <HeroSection />

      <Suspense
        fallback={
          <div
            role="status"
            aria-live="polite"
            className="h-[400px] flex items-center justify-center"
          >
            Loading...
          </div>
        }
      >
        <OverviewSection />
        <DynamicLearningSection />
        <BenefitSection />
        <SupportSection />
        <FeaturesSection />
      </Suspense>
    </main>
  );
};

export default Education;